import * as React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from 'components/ui/dialog';

const Modal = ({
  isOpen = false,
  onOpenChange = () => {},
  title = null,
  description = null,
  children = null,
  className = null,
  footer = null,
  icon = null,
  isUnclosable = false,
}) => {
  const handleEscapeKey = (e) => {
    if (isUnclosable) {
      e.preventDefault();
    }
  };

  const handlePointerDown = (e) => {
    if (isUnclosable) {
      e.preventDefault();
    }
  };
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className={`bg-white rounded-xl shadow-lg max-w-[90%] lg:max-w-xl w-full p-4 max-h-[90vh] !h-auto overflow-y-auto ${className}`}
        onEscapeKeyDown={handleEscapeKey}
        onPointerDownOutside={handlePointerDown}
      >
        <div className="flex items-center self-start">
          {icon && <div className="mr-2">{icon}</div>}
          {title && (
            <DialogHeader className="flex items-center">
              <DialogTitle>{title}</DialogTitle>
              {description && <DialogDescription className="text-gray-500">{description}</DialogDescription>}
            </DialogHeader>
          )}
        </div>

        <div className="my-">{children}</div>

        {footer && <DialogFooter className="self-end gap-2">{footer}</DialogFooter>}
      </DialogContent>
    </Dialog>
  );
};

Modal.propTypes = {
  isOpen: PropTypes.bool,
  isUnclosable: PropTypes.bool,
  onOpenChange: PropTypes.func,
  title: PropTypes.string,
  description: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
  footer: PropTypes.node,
  icon: PropTypes.node,
};

export default Modal;
